import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "Store/store";

export { default as useAllowedTo } from "./useAllowedTo";
export { default as useBelongsToGroup } from "./useBelongsToGroup";
export { default as useCatalogRoute } from "./useCatalogRoute";
export { default as useCheckPaginationPage } from "./useCheckPaginationPage";
export { default as useCurrentOrganization } from "./useCurrentOrganization";
export { default as useDialog } from "./useDialog";
export { default as useFileUploadChecks } from "./useFileUploadChecks";
export { default as useFilterSortPaginationWithUrl } from "./useFilterSortPaginationWithUrl";
export { default as useGroup } from "./useGroup";
export { default as useIsAiFeatureEnabled } from "./useIsAiFeatureEnabled";
export { default as useIsAuthenticated } from "./useIsAuthenticated";
export { default as useIsRestoredId } from "./useIsRestoredId";
export { default as useLoginInfo } from "./useLoginInfo";
export { default as usePercentageSlider } from "./usePercentageSlider";
export { default as useProjectsRoute } from "./useProjectsRoute";
export { default as useRedirect } from "./useRedirect";
export { default as useReports } from "./useReports";
export { default as useScript } from "./useScript";
export { default as useUploadOption } from "./useUploadOption";
export { default as useUsageQuota } from "./useUsageQuota";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
